module.exports = __webpack_public_path__ + "static/media/shirtBig.86dc0ee1.png";